// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
    IconBug,
    IconLayoutDashboard,
    IconUsers,
    IconUserCircle,
    IconChecklist,
    IconFileAnalytics,
    IconReceipt,
    IconShoppingCartDiscount,
    IconTicket,
    IconRocket,
    IconQuestionMark,
    IconSettings,
    IconBulb,
    IconChartBar,
    IconTruck,
    IconBrandMercedes,
    IconCalendarEvent,
    IconCalendarStats,
    IconConfetti,
    IconCash,
    IconSocial,
    IconMessage2,
    IconSubtask,
    IconUser,
    IconBuilding,
    IconSteeringWheel,
    IconClock,
    IconChevronRight,
    IconUserSearch,
    IconBuildingWarehouse,
    IconTruckLoading,
    IconBell,
    IconComponents,
    IconCalendarMinus,
    IconMapPin,
    IconWorld,
    IconBuildingBank,
    IconBuildingSkyscraper,
    IconBooks,
    IconShip,
    IconApiApp
} from '@tabler/icons';

// constant
const icons = {
    IconBug,
    IconLayoutDashboard,
    IconUsers,
    IconUserCircle,
    IconChecklist,
    IconFileAnalytics,
    IconReceipt,
    IconShoppingCartDiscount,
    IconTicket,
    IconRocket,
    IconChartBar,
    IconQuestionMark,
    IconSettings,
    IconBulb,
    IconTruck,
    IconBrandMercedes,
    IconCalendarEvent,
    IconCalendarStats,
    IconConfetti,
    IconCash,
    IconMessage2,
    IconSubtask,
    IconUser,
    IconBuilding,
    IconSteeringWheel,
    IconClock,
    IconChevronRight,
    IconSocial,
    IconUserSearch,
    IconBuildingWarehouse,
    IconTruckLoading,
    IconBell,
    IconComponents,
    IconCalendarMinus,
    IconMapPin,
    IconWorld,
    IconBuildingBank,
    IconBuildingSkyscraper,
    IconBooks,
    IconShip,
    IconApiApp
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
    id: 'pages',
    type: 'group',
    permissionID: 'All',
    children: [
        {
            id: 'dashboard',
            title: <FormattedMessage id="dashboard" />,
            type: 'item',
            icon: icons.IconLayoutDashboard,
            url: '/dashboard',
            permissionID: 'All'
        },
        {
            id: 'social-lead',
            title: <FormattedMessage id="contacts" />,
            type: 'collapse',
            icon: icons.IconRocket,
            children: [
                {
                    id: 'social-lead',
                    title: <FormattedMessage id="contact list" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/contacts',
                    permissionID: 'business-read'
                },
                {
                    id: 'contactTracking',
                    title: <FormattedMessage id="contact tracking" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/contact-tracking',
                    permissionID: 'business-read'
                }
                // {
                //     id: 'contactNotesList',
                //     title: <FormattedMessage id="contact notes list" />,
                //     type: 'item',
                //     icon: icons.IconApiApp,
                //     url: '/contact-notes-list',
                //     permissionID: 'contacts-read'
                // }
            ]
        },
        // {
        //     id: 'the-radar',
        //     title: <FormattedMessage id="Radar" />,
        //     type: 'item',
        //     icon: icons.IconRocket,
        //     url: '/the-radar',
        //     permissionID: 'radar-read'
        // },

        // {
        //     id: 'customers',
        //     title: <FormattedMessage id="Potential Customer" />,
        //     type: 'item',
        //     icon: icons.IconRocket,
        //     url: '/potential-customers',
        //     permissionID: 'Customer-read'
        // },
        {
            id: 'customers',
            title: <FormattedMessage id="Potential Customer" />,
            type: 'collapse',
            icon: icons.IconRocket,
            children: [
                {
                    id: 'customers',
                    title: <FormattedMessage id="customer-list" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/potential-customers',
                    permissionID: 'Customer-read'
                },
                {
                    id: 'customersTracking',
                    title: <FormattedMessage id="customers tracking" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/customers-tracking',
                    permissionID: 'customers-read'
                },
                {
                    id: 'customerNotesList',
                    title: <FormattedMessage id="Potential Customers notes list" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/potential-customers-notes-list',
                    permissionID: 'business-read'
                }
            ]
        },
        // {
        //     id: 'cartons',
        //     title: <FormattedMessage id="cartons" />,
        //     type: 'item',
        //     icon: icons.IconRocket,
        //     url: '/cartons',
        //     permissionID: 'Carton-read'
        // },
        {
            id: 'cartons',
            title: <FormattedMessage id="cartons" />,
            type: 'collapse',
            icon: icons.IconRocket,
            children: [
                {
                    id: 'cartons',
                    title: <FormattedMessage id="cartons registered" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/cartons',
                    permissionID: 'Carton-read'
                },
                {
                    id: 'potentailCartons',
                    title: <FormattedMessage id="cartons verified" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/potential-cartons',
                    permissionID: 'cartons-read'
                }
                // {
                //     id: 'cartonsEstimation',
                //     title: <FormattedMessage id="cartons quoted" />,
                //     type: 'item',
                //     icon: icons.IconApiApp,
                //     url: '/cartons-estimation',
                //     permissionID: 'Carton-read'
                // }
            ]
        },
        {
            id: 'machines',
            title: <FormattedMessage id="machines" />,
            type: 'item',
            icon: icons.IconRocket,
            url: '/machines',
            permissionID: 'Machine-read'
        },
        {
            id: 'spare-parts',
            title: <FormattedMessage id="spare-parts" />,
            type: 'item',
            icon: icons.IconRocket,
            url: '/spareparts',
            permissionID: 'SparePart-read'
        },
        {
            id: 'quotation-request',
            title: <FormattedMessage id="quotes" />,
            type: 'item',
            icon: icons.IconRocket,
            url: '/quotes',
            permissionID: 'Quotes-read'
        },
        // {
        //     id: 'Sample-request',
        //     title: <FormattedMessage id="Samples" />,
        //     type: 'item',
        //     icon: icons.IconRocket,
        //     url: '/samples',
        //     permissionID: 'Sample-read'
        // },

        // {
        //     id: 'orders',
        //     title: <FormattedMessage id="orders" />,
        //     type: 'item',
        //     icon: icons.IconUsers,
        //     url: '/orders',
        //     permissionID: 'order-read'
        // },
        // {
        //     id: 'staff',
        //     title: <FormattedMessage id="astronauts" />,
        //     type: 'item',
        //     icon: icons.IconRocket,
        //     url: '/astronauts',
        //     permissionID: 'Astronaut-read'
        // },
        {
            id: 'staff',
            title: <FormattedMessage id="astronauts" />,
            type: 'collapse',
            icon: icons.IconUserSearch,
            children: [
                {
                    id: 'staff',
                    title: <FormattedMessage id="astronauts list" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/astronauts',
                    permissionID: 'Astronaut-read'
                },
                {
                    id: 'astronautsTracking',
                    title: <FormattedMessage id="astronauts tracking" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/astronauts-tracking',
                    permissionID: 'Astronaut-read'
                }
            ]
        },

        {
            id: 'reports',
            title: <FormattedMessage id="reports" />,
            type: 'item',
            icon: icons.IconChartBar,
            url: '/reports',
            permissionID: 'Report-read'
        },
        {
            id: 'careers',
            title: <FormattedMessage id="candidates" />,
            type: 'item',
            icon: icons.IconBell,
            url: '/careers',
            permissionID: 'Career-read'
        },
        {
            id: 'principals',
            title: <FormattedMessage id="commanders" />,
            type: 'item',
            icon: icons.IconUser,
            url: '/principals',
            // permissionID: 'users-read'
            role: ['Admin']
        },

        {
            id: 'settings',
            title: <FormattedMessage id="settings" />,
            type: 'collapse',
            icon: icons.IconSettings,
            role: ['Admin'],
            children: [
                // {
                //     id: 'roles-departments',
                //     title: <FormattedMessage id="roles-departments" />,
                //     type: 'collapse',
                //     icon: icons.IconSubtask,
                //     children: [
                //         // {
                //         //     id: 'roles',
                //         //     title: <FormattedMessage id="roles" />,
                //         //     type: 'item',
                //         //     icon: icons.IconUser,
                //         //     url: '/setting/roles',
                //         //     permissionID: 'Role-read'
                //         // },
                //         // {
                //         //     id: 'departments',
                //         //     title: <FormattedMessage id="departments" />,
                //         //     type: 'item',
                //         //     icon: icons.IconBuilding,
                //         //     url: '/setting/departments',
                //         //     permissionID: 'Department-read'
                //         // }
                //         // {
                //         //     id: 'documents-types',
                //         //     title: <FormattedMessage id="documents-types" />,
                //         //     type: 'item',
                //         //     icon: icons.IconBooks,
                //         //     url: '/setting/documents-types',
                //         //     permissionID: 'documentsTypes-read'
                //         // }
                //     ]
                // },
                // {
                //     id: 'staff-management',
                //     title: <FormattedMessage id="staff-management" />,
                //     type: 'collapse',
                //     icon: icons.IconUsers,
                //     children: [
                //         {
                //             id: 'shift',
                //             title: <FormattedMessage id="shift" />,
                //             type: 'item',
                //             icon: icons.IconClock,
                //             url: '/setting/shift',
                //             permissionID: 'Shift-read'
                //         },
                //         {
                //             id: 'leave-type',
                //             title: <FormattedMessage id="leave-type" />,
                //             type: 'item',
                //             icon: icons.IconCalendarMinus,
                //             url: '/setting/leave-type',
                //             permissionID: 'LeaveType-read'
                //         }
                //     ]
                // },
                {
                    id: 'front-setting',
                    title: <FormattedMessage id="front-setting" />,
                    type: 'item',
                    icon: icons.IconUsers,
                    url: '/setting/front-setting',
                    permissionID: 'frontsetting-read'
                },
                // {
                //     id: 'testimonial',
                //     title: <FormattedMessage id="testimonial" />,
                //     type: 'item',
                //     icon: icons.IconUsers,
                //     url: '/setting/testimonial',
                //     permissionID: 'testimonial-read'
                // },
                // {
                //     id: 'holiday',
                //     title: <FormattedMessage id="holiday" />,
                //     type: 'item',
                //     icon: icons.IconConfetti,
                //     url: '/setting/holidays',
                //     permissionID: 'Holiday-read'
                // },
                {
                    id: 'status',
                    title: <FormattedMessage id="Status" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/setting/status',
                    permissionID: 'Status-read'
                }
                // {
                //     id: 'country',
                //     title: <FormattedMessage id="country" />,
                //     type: 'item',
                //     icon: icons.IconApiApp,
                //     url: '/setting/countries',
                //     permissionID: 'Country-read'
                // },
                // {
                //     id: 'state',
                //     title: <FormattedMessage id="state" />,
                //     type: 'item',
                //     icon: icons.IconApiApp,
                //     url: '/setting/states',
                //     permissionID: 'State-read'
                // }
            ]
        },
        // {
        //     id: 'contact-managment',
        //     title: <FormattedMessage id="contacts" />,
        //     type: 'collapse',
        //     icon: icons.IconUserSearch,
        //     children: [
        //         {
        //             id: 'contactTracking',
        //             title: <FormattedMessage id="contact tracking" />,
        //             type: 'item',
        //             icon: icons.IconRocket,
        //             url: '/contact-tracking',
        //             permissionID: 'business-read'
        //         }
        //     ]
        // },
        {
            id: 'hrm',
            title: <FormattedMessage id="control astronauts" />,
            type: 'collapse',
            icon: icons.IconUserSearch,
            role: ['Admin'],
            children: [
                {
                    id: 'attendance',
                    title: <FormattedMessage id="attendance" />,
                    type: 'item',
                    icon: icons.IconCalendarEvent,
                    url: '/hrm/attendance',
                    permissionID: 'Attendance-read'
                },
                {
                    id: 'leaves',
                    title: <FormattedMessage id="leaves" />,
                    type: 'item',
                    icon: icons.IconCalendarStats,
                    url: '/hrm/leaves',
                    permissionID: 'Leave-read'
                },
                {
                    id: 'announcement',
                    title: <FormattedMessage id="announcement" />,
                    type: 'item',
                    icon: icons.IconBell,
                    url: '/hrm/announcements',
                    permissionID: 'Announcement-read'
                },
                {
                    id: 'roles',
                    title: <FormattedMessage id="roles" />,
                    type: 'item',
                    icon: icons.IconUser,
                    url: '/setting/roles',
                    permissionID: 'Role-read'
                },
                {
                    id: 'departments',
                    title: <FormattedMessage id="spaceships" />,
                    type: 'item',
                    icon: icons.IconRocket,
                    url: '/setting/spaceships',
                    permissionID: 'Department-read'
                },
                {
                    id: 'shift',
                    title: <FormattedMessage id="shift" />,
                    type: 'item',
                    icon: icons.IconClock,
                    url: '/setting/shift',
                    permissionID: 'Shift-read'
                },
                {
                    id: 'leave-type',
                    title: <FormattedMessage id="leave-type" />,
                    type: 'item',
                    icon: icons.IconCalendarMinus,
                    url: '/setting/leave-type',
                    permissionID: 'LeaveType-read'
                },
                {
                    id: 'testimonial',
                    title: <FormattedMessage id="testimonial" />,
                    type: 'item',
                    icon: icons.IconUsers,
                    url: '/setting/testimonial',
                    permissionID: 'testimonial-read'
                },
                {
                    id: 'holiday',
                    title: <FormattedMessage id="holiday" />,
                    type: 'item',
                    icon: icons.IconConfetti,
                    url: '/setting/holidays',
                    permissionID: 'Holiday-read'
                },
                {
                    id: 'followUpAstronaut',
                    title: <FormattedMessage id="follow-up astronaut" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/control-astronauts/follow-up-astronaut',
                    permissionID: 'followUpAstronaut-read'
                },
                {
                    id: 'followUpSupervisor',
                    title: <FormattedMessage id="follow-up supervisor" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/control-astronauts/follow-up-supervisor',
                    permissionID: 'followUpSupervisor-read'
                },
                {
                    id: 'progressAstronaut',
                    title: <FormattedMessage id="progress astronaut" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/control-astronauts/progress-astronaut',
                    permissionID: 'progressAstronaut-read'
                },
                {
                    id: 'statusSupervisor',
                    title: <FormattedMessage id="status supervisor" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/control-astronauts/status-supervisor',
                    permissionID: 'statusSupervisor-read'
                }
            ]
        },
        // {
        //     id: 'support-tickets',
        //     title: <FormattedMessage id="support-tickets" />,
        //     type: 'item',
        //     icon: icons.IconTicket,
        //     url: '/support-tickets',
        //     permissionID: 'SupportTicket-read'
        // },

        // --------------
        {
            id: 'contact-managment',
            title: <FormattedMessage id="control contacts" />,
            type: 'collapse',
            role: ['Admin'],
            icon: icons.IconUserSearch,
            children: [
                {
                    id: 'business',
                    title: <FormattedMessage id="business" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/contact-managment/business',
                    permissionID: 'business-read'
                },
                {
                    id: 'channel',
                    title: <FormattedMessage id="channel" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/contact-managment/channel',
                    permissionID: 'channel-read'
                },
                {
                    id: 'country',
                    title: <FormattedMessage id="country" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/setting/countries',
                    permissionID: 'Country-read'
                },
                {
                    id: 'state',
                    title: <FormattedMessage id="state" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/setting/states',
                    permissionID: 'State-read'
                },
                {
                    id: 'followUpAstronaut',
                    title: <FormattedMessage id="follow-up astronaut" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/contact-managment/follow-up-astronaut',
                    permissionID: 'followUpAstronaut-read'
                },
                {
                    id: 'followUpSupervisor',
                    title: <FormattedMessage id="follow-up supervisor" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/contact-managment/follow-up-supervisor',
                    permissionID: 'followUpSupervisor-read'
                },
                {
                    id: 'progressAstronaut',
                    title: <FormattedMessage id="progress astronaut" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/contact-managment/progress-astronaut',
                    permissionID: 'progressAstronaut-read'
                },
                {
                    id: 'statusSupervisor',
                    title: <FormattedMessage id="status supervisor" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/contact-managment/status-supervisor',
                    permissionID: 'statusSupervisor-read'
                }
            ]
        },
        {
            id: 'items-managment',
            title: <FormattedMessage id="control cartons" />,
            type: 'collapse',
            role: ['Admin'],
            icon: icons.IconUserSearch,
            children: [
                {
                    id: 'style',
                    title: <FormattedMessage id="style" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/style',
                    permissionID: 'style-read'
                },
                {
                    id: 'endurance',
                    title: <FormattedMessage id="material" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/material',
                    permissionID: 'endurance-read'
                },
                {
                    id: 'glued',
                    title: <FormattedMessage id="Glued" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/glued',
                    permissionID: 'glued-read'
                },
                {
                    id: 'inks',
                    title: <FormattedMessage id="inks" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/inks',
                    permissionID: 'inks-read'
                },
                {
                    id: 'record',
                    title: <FormattedMessage id="record" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/record',
                    permissionID: 'record-read'
                },
                {
                    id: 'strapling-direction',
                    title: <FormattedMessage id="straping direction" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/strapling-direction',
                    permissionID: 'strapling-direction-read'
                },
                {
                    id: 'boxes-bound',
                    title: <FormattedMessage id="boxes/bound" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/boxes-bound',
                    permissionID: 'boxes-bound-read'
                },
                {
                    id: 'item-types',
                    title: <FormattedMessage id="ink type" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/ink-type',
                    permissionID: 'item-types-read'
                },
                {
                    id: 'standard-pack',
                    title: <FormattedMessage id="standard pack" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/standard-pack',
                    permissionID: 'standard-pack-read'
                },
                {
                    id: 'stretch-or-stretch-film',
                    title: <FormattedMessage id="stretch or stretch film" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/stretch-or-stretch-film',
                    permissionID: 'standard-pack-read'
                },
                {
                    id: 'pallet-or-pallet',
                    title: <FormattedMessage id="pallet or pallet" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/pallet-or-pallet',
                    permissionID: 'pallet-or-pallet-read'
                },
                {
                    id: 'includes-tooling-cost',
                    title: <FormattedMessage id="includes tooling cost" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/includes-tooling-cost',
                    permissionID: 'includes-tooling-cost-read'
                },
                {
                    id: 'includes-engraving-cost',
                    title: <FormattedMessage id="includes engraving cost" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/includes-engraving-cost',
                    permissionID: 'includes-engraving-cost-read'
                },
                {
                    id: 'includes-shipping-to-your-plant',
                    title: <FormattedMessage id="includes shipping to your plant" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/includes-shipping-to-your-plant',
                    permissionID: 'includes-shipping-to-your-plant-read'
                },
                {
                    id: 'delivery-city',
                    title: <FormattedMessage id="delivery city" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/items-managment/delivery-city',
                    permissionID: 'delivery-city-read'
                }
            ]
        },
        {
            id: 'controlCustomers',
            title: <FormattedMessage id="control customers" />,
            type: 'collapse',
            icon: icons.IconUserSearch,
            role: ['Admin'],
            children: [
                {
                    id: 'followUpCustomer',
                    title: <FormattedMessage id="follow-up customer" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/control-customer/follow-up-customer',
                    permissionID: 'followUpCustomer-read'
                },
                {
                    id: 'followUpSupervisor',
                    title: <FormattedMessage id="follow-up supervisor" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/control-customer/follow-up-supervisor',
                    permissionID: 'followUpSupervisor-read'
                },
                {
                    id: 'progressCustomer',
                    title: <FormattedMessage id="progress customer" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/control-customer/progress-customer',
                    permissionID: 'progressCustomer-read'
                },
                {
                    id: 'statusSupervisor',
                    title: <FormattedMessage id="status supervisor" />,
                    type: 'item',
                    icon: icons.IconApiApp,
                    url: '/control-customer/status-supervisor',
                    permissionID: 'statusSupervisor-read'
                }
            ]
        },
        {
            id: 'candidates-estimation',
            title: <FormattedMessage id="control quotations" />,
            type: 'collapse',
            role: ['Admin'],
            icon: icons.IconUserSearch,
            children: [
                {
                    id: 'terms',
                    title: <FormattedMessage id="terms-condition" />,
                    type: 'item',
                    icon: icons.IconUsers,
                    url: '/control-economic-estimation/terms-condition',
                    permissionID: 'position-read'
                }
            ]
        },
        {
            id: 'candidates-managment',
            title: <FormattedMessage id="control candidates" />,
            type: 'collapse',
            role: ['Admin'],
            icon: icons.IconUserSearch,
            children: [
                {
                    id: 'position',
                    title: <FormattedMessage id="position" />,
                    type: 'item',
                    icon: icons.IconUsers,
                    url: '/setting/position',
                    permissionID: 'position-read'
                }
            ]
        }
    ]
};

export default pages;
